export default "__VITE_ASSET__CGi1CIM___"